import { render, staticRenderFns } from "./SliderWidget.vue?vue&type=template&id=66350eb3&scoped=true&"
import script from "./SliderWidget.vue?vue&type=script&lang=js&"
export * from "./SliderWidget.vue?vue&type=script&lang=js&"
import style0 from "./SliderWidget.vue?vue&type=style&index=0&id=66350eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66350eb3",
  null
  
)

export default component.exports